export const usePositioning = ({ 
  isSelected, 
  isHovered, 
  editable, 
  position, 
  lockedEdges, 
  top, 
  left, 
  right, 
  bottom, 
  unit,
  backgroundColor,
  borderRadius,
  padding,
  style
}) => {
  const getSelectionStyle = () => {
    if (isSelected && !editable) {
      return {
        outline: '1px dashed #2196f3',
        outlineOffset: '2px'
      };
    }
    if (isHovered && !editable) {
      return {
        outline: '1px dashed #ff9800',
        outlineOffset: '1px'
      };
    }
    return {};
  };

  const getPositionStyle = () => {
    if (position === 'absolute' || position === 'relative') {
      const positionStyle = { position };
      
      if (lockedEdges.top && top !== undefined) {
        positionStyle.top = `${top}${unit}`;
      }
      if (lockedEdges.left && left !== undefined) {
        positionStyle.left = `${left}${unit}`;
      }
      if (lockedEdges.right && right !== undefined) {
        positionStyle.right = `${right}${unit}`;
      }
      if (lockedEdges.bottom && bottom !== undefined) {
        positionStyle.bottom = `${bottom}${unit}`;
      }
      
      return positionStyle;
    }
    return { position };
  };

  const getContainerStyle = () => ({
    transition: 'all 0.2s ease',
    display: 'inline-block',
    backgroundColor: backgroundColor,
    borderRadius: borderRadius ? `${borderRadius}px` : undefined,
    padding: padding ? `${padding}px` : undefined,
    ...getPositionStyle(),
    ...style,
    ...getSelectionStyle()
  });

  const getTextStyle = ({ fontSize, fontFamily, fontWeight, fontStyle, textAlign, color }) => ({
    fontSize: `${fontSize}px`,
    fontFamily: fontFamily,
    fontWeight: fontWeight,
    fontStyle: fontStyle,
    textAlign: textAlign,
    color: color,
    outline: editable ? '1px dashed #ccc' : 'none',
    margin: 0,
    padding: 0
  });

  return {
    containerStyle: getContainerStyle(),
    getTextStyle
  };
};